import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconArrowUpRightComponent = ({ color = petrol.main, fontSize = '20px', ...rest }) => {
  return (
    <SvgIcon sx={{ color, fontSize }} {...rest} strokeWidth={2}>
      <path
        d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const IconArrowUpRight = memo(IconArrowUpRightComponent);

export default IconArrowUpRight;
